// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OtdCard_card__CApWM {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  border-radius: 18px;
  box-shadow: var(--shadow-card);
  padding: 18px 20px;
}

/* Filtro de rango del OTD */
.OtdCard_filter__aVR4w {
  display: flex;
  gap: 6px;
}
.OtdCard_filterBtn__dNI2v {
  flex: 1 1;
  padding: 6px 8px;
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 600;
  color: var(--dylo-muted);
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}
.OtdCard_filterBtn__dNI2v:hover {
  color: var(--dylo-ink);
  border-color: var(--dylo-orange);
}
.OtdCard_filterActive__53gVi {
  color: #fff;
  background: var(--dylo-orange);
  border-color: var(--dylo-orange);
}

/* Contenido: donut + info (fila horizontal) */
.OtdCard_content__7nzyl {
  display: flex;
  align-items: center;
  gap: 16px;
  transition: opacity 0.15s ease;
}
.OtdCard_contentLoading__25y\\+I {
  opacity: 0.55;
}

.OtdCard_donut__Y8Vwd {
  position: relative;
  width: 84px;
  height: 84px;
  flex-shrink: 0;
}
.OtdCard_donutLabel__SRIPR {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: var(--dylo-ink);
}

.OtdCard_info__iwxlh {
  min-width: 0;
}
.OtdCard_title__r5z0D {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--dylo-text);
  margin: 0;
  line-height: 1.25;
}
.OtdCard_infoIcon__O6TvA {
  display: inline-flex;
  align-items: center;
  color: var(--dylo-muted);
  cursor: help;
  flex-shrink: 0;
}
.OtdCard_infoIcon__O6TvA:hover {
  color: var(--dylo-orange);
}
.OtdCard_rate__\\+2C\\+f {
  font-size: 22px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 2px 0 4px;
}
.OtdCard_detail__yX3HO {
  font-size: 12px;
  color: var(--dylo-muted);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/OtdCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  border-radius: 18px;\n  box-shadow: var(--shadow-card);\n  padding: 18px 20px;\n}\n\n/* Filtro de rango del OTD */\n.filter {\n  display: flex;\n  gap: 6px;\n}\n.filterBtn {\n  flex: 1;\n  padding: 6px 8px;\n  font-family: var(--font-sans);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--dylo-muted);\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n.filterBtn:hover {\n  color: var(--dylo-ink);\n  border-color: var(--dylo-orange);\n}\n.filterActive {\n  color: #fff;\n  background: var(--dylo-orange);\n  border-color: var(--dylo-orange);\n}\n\n/* Contenido: donut + info (fila horizontal) */\n.content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: opacity 0.15s ease;\n}\n.contentLoading {\n  opacity: 0.55;\n}\n\n.donut {\n  position: relative;\n  width: 84px;\n  height: 84px;\n  flex-shrink: 0;\n}\n.donutLabel {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n}\n\n.info {\n  min-width: 0;\n}\n.title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--dylo-text);\n  margin: 0;\n  line-height: 1.25;\n}\n.infoIcon {\n  display: inline-flex;\n  align-items: center;\n  color: var(--dylo-muted);\n  cursor: help;\n  flex-shrink: 0;\n}\n.infoIcon:hover {\n  color: var(--dylo-orange);\n}\n.rate {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 2px 0 4px;\n}\n.detail {\n  font-size: 12px;\n  color: var(--dylo-muted);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `OtdCard_card__CApWM`,
	"filter": `OtdCard_filter__aVR4w`,
	"filterBtn": `OtdCard_filterBtn__dNI2v`,
	"filterActive": `OtdCard_filterActive__53gVi`,
	"content": `OtdCard_content__7nzyl`,
	"contentLoading": `OtdCard_contentLoading__25y+I`,
	"donut": `OtdCard_donut__Y8Vwd`,
	"donutLabel": `OtdCard_donutLabel__SRIPR`,
	"info": `OtdCard_info__iwxlh`,
	"title": `OtdCard_title__r5z0D`,
	"infoIcon": `OtdCard_infoIcon__O6TvA`,
	"rate": `OtdCard_rate__+2C+f`,
	"detail": `OtdCard_detail__yX3HO`
};
export default ___CSS_LOADER_EXPORT___;
